import { CustomerProfiles } from '@cupoui/shared/model/customerProfiles';

export class CustomerProfilePermission {
  customerProfiles: CustomerProfiles[];
}
